import React from 'react';
import { Divider } from 'antd';
import _ from 'lodash';
import PageFrame from '../../views/PageFrame';
import Clamper from '../../views/ContentWidthClamper';
import HeadlineBreadcrumbList from '../../views/HeadlineBreadcrumbList';
import { FormRow } from '../../views/Form';
import Input from '../../views/InputBouncy';
import TextAreaB from '../../views/TextAreaBouncy';
import ButtonList from '../../views/ButtonList';
import Button from '../../views/StyledButton';
import { HelpText } from '../../views/typography';
import VBQLArea from '../../views/VBQLArea.js';

const LINE_HEIGHT = 21;
const NOTES_LINES = 3;
const DESC_LINES = 3;
const QUERY_LINES = 7;
const TAGS_LINES = 3;


function mh(n) {
  return (n * (1 + LINE_HEIGHT)) + 5;
}

export default ({
  title, goHome, cat, newCat, goBack,
  tagsText, chooseTagsText, canSave, save, loaded, loading,
  chooseVersion, chooseName, chooseDescription, chooseQuery, chooseNotes,
}) => (
  <PageFrame>
    <Clamper>
      <HeadlineBreadcrumbList>
        {[
          { onClick: goHome, text: 'Home' },
          { onClick: goBack, text: 'Categories' },
          title,
        ]}
      </HeadlineBreadcrumbList>
      {loaded && <React.Fragment>
        <FormRow label="Name" minHeight={mh(1)} bottomMargin={8} labelSpan={4}>
          <Input value={_.get(cat, 'categoryName')} readOnly={!newCat} onChange={chooseName} />
          <HelpText>Give your category a unique SQL-safe name.</HelpText>
        </FormRow>

        <VBQLArea value={_.get(cat, 'query', '')}
                  onChange={chooseQuery}
        />
        <HelpText>
          The VBQL query that will be used to match incoming media.
        </HelpText>

        <Divider />

        <FormRow label="Description" bottomMargin={8} minHeight={(mh(DESC_LINES))} labelSpan={4}>
          <TextAreaB
            value={_.get(cat, 'categoryDescription', '')}
            minRows={DESC_LINES}
            maxRows={4}
            onChange={chooseDescription}
          />
          <HelpText>Describe the purpose of your category.</HelpText>
        </FormRow>

        <FormRow label="Notes" bottomMargin={8} minHeight={mh(NOTES_LINES)} labelSpan={4}>
          <TextAreaB
            value={_.get(cat, 'notes', '')}
            minRows={NOTES_LINES}
            onChange={chooseNotes}
          />
          <HelpText> Enter some notes to help your team.</HelpText>
        </FormRow>

        <FormRow label="Tags (1 per row)" bottomMargin={8} minHeight={mh(TAGS_LINES)} labelSpan={4}>
          <TextAreaB
            value={tagsText}
            minRows={TAGS_LINES}
            maxRows={6}
            onChange={chooseTagsText}
          />
          <HelpText> Add tags to help organize your categories</HelpText>
        </FormRow>

        <FormRow label="Version" minHeight={42} bottomMargin={8} labelSpan={4}>
          <Input value={_.get(cat, 'version')} onChange={chooseVersion} />
          <HelpText>Give your query a version to help track changes.</HelpText>
        </FormRow>
      </React.Fragment>
      }
      <ButtonList>
        <Button type="primary" disabled={!(loaded && canSave)} onClick={save}>
          {newCat ? 'Create Category' : 'Save Category'}
        </Button>
      </ButtonList>
    </Clamper>
  </PageFrame>
);

